import { render, staticRenderFns } from "./Allotment.vue?vue&type=template&id=5aa47728&"
import script from "./Allotment.vue?vue&type=script&lang=js&"
export * from "./Allotment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports